// Строка вывода - Метка: значение для демо-форм
const template = `
    <div class="frow" :class="className">
        <div
            v-if="label"
            :class="[className + '-key', keyClassMod?className + '-key--' + keyClassMod:'']"
        >
            <template v-if="label != ' '">
                [[ label ]]<template v-if="showColon">:</template>
            </template>
        </div>
        <div :class="className + '-value'" :data-ref="index">
            <slot></slot>
        </div>
    </div>`;

const props = {
    label: String,
    index: String,
    className: {
        type: String,
        default: "clean-demo-result__item",
    },
    keyClassMod: {
        type: String,
        default: "",
    },
    showColon: {
        type: Boolean,
        default: true,
    },
};

export default {
    template,
    props,
};
